module.exports = __webpack_public_path__ + "static/home-quote-bg-c34805241c3ff4ed80501c3d8f26367f.jpg";